import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const LFOpen = ({
  size = 14,
  title = 'Open',
  fill = colors.trafficCone,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 15 12.18">
      {Boolean(title) && <title>{title}</title>}
      <path
        fill={fill}
        d="M0 .72v10.74a.72.72 0 00.72.72H13a.72.72 0 00.72-.72V.72A.72.72 0 0013 0H.72A.72.72 0 000 .72zm10.9.77L7.33 4.72a.73.73 0 01-.94 0l-4-3.27zm-9.42 8.92V2.3L6.4 6.63a.72.72 0 00.95 0l4.91-4.33v8.11a.29.29 0 01-.29.29H1.77a.28.28 0 01-.28-.29z"
      />
    </svg>
  );
};
